<label
  [for]="inputId || name"
  [ngClass]="[screenReaderLabelDesktopOnly ? 'visually-hidden-md-up' : 'visually-hidden', 'my-0']"
  *ngIf="screenReaderLabel || placeholder"
>
  {{ screenReaderLabel || placeholder }}
</label>
<div class="position-relative search-field-wrapper" [class.with-large-icons]="iconSize === 'large'">
  <shrd-uic-input-expandable-field
    class="shrd-uic-search-field-input"
    [class.has-barcode]="isBarcodeScannerEnabled"
    [type]="type"
    [autofocus]="autofocus"
    [name]="name"
    [inputId]="inputId"
    [placeholder]="placeholder"
    [style.max-width]="maxWidth"
    [maxlength]="maxlength"
    [disabled]="disabled"
    [autocomplete]="false"
    [expandOnFocusSize]="expandOnFocusSize"
    [value]="value"
    expandOnFocusChildClass="shrd-uic-search-field-btn-clear"
    (keydown.enter)="onSearch($any($event), searchBtn)"
    #searchField
  ></shrd-uic-input-expandable-field>
  <div class="input-group-append d-flex align-items-center h-100">
    <button
      #resetBtn
      *ngIf="searchField.value"
      type="button"
      (click)="resetValue()"
      class="shrd-uic-search-field-btn shrd-uic-search-field-btn-clear"
      [title]="resetTitle"
      (keydown.escape)="restoreInitialState(resetBtn)"
    >
      <shrd-uic-svg-icon [icon]="iconName.CLEAR" [size]="iconSize"></shrd-uic-svg-icon>
    </button>
    <button
      #barcodeScanBtn
      *ngIf="isBarcodeScannerEnabled"
      type="button"
      class="shrd-uic-search-field-btn btn-barcode-scan"
      [title]="barcodeTitle"
      (click)="barcodeScannerTriggered.emit()"
      (keydown.escape)="restoreInitialState(barcodeScanBtn)"
    >
      <shrd-uic-svg-icon [icon]="barcodeScannerIcon" [size]="iconSize"></shrd-uic-svg-icon>
    </button>
    <button
      #searchBtn
      type="button"
      (click)="onSearch($event, searchBtn)"
      class="shrd-uic-search-field-btn shrd-uic-search-field-btn-emit"
      [title]="buttonTitle"
      (keydown.escape)="restoreInitialState(searchBtn)"
    >
      <shrd-uic-svg-icon [icon]="iconName.SEARCH" [size]="iconSize"></shrd-uic-svg-icon>
    </button>
    <shrd-uic-preloader *ngIf="usePreloader" class="bg-light" size="x-small" [active]="loading"></shrd-uic-preloader>
  </div>
</div>
